import { useEffect } from "react";

// Reveal-on-scroll: gracefully degrades when JS is disabled or observer never fires.
// We mark <body> as js-ready so the "hidden" state only applies once JS is running,
// then promote to "in" state when entering the viewport.
export default function useReveal() {
  useEffect(() => {
    document.body.classList.add("js-ready");
    const els = document.querySelectorAll(".reveal");

    const promote = (el) => {
      el.classList.add("in");
    };

    // Promote anything already on screen at mount (avoids stuck hidden state)
    els.forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.95) promote(el);
    });

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            promote(e.target);
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -8% 0px" }
    );
    els.forEach((el) => {
      if (!el.classList.contains("in")) io.observe(el);
    });

    // Safety net: after 2.5s, force anything still hidden into view
    const t = setTimeout(() => {
      document.querySelectorAll(".reveal:not(.in)").forEach(promote);
    }, 2500);

    return () => {
      io.disconnect();
      clearTimeout(t);
    };
  }, []);
}
